import { AddDeviceGlobalState } from "@/features/add-device/add-device-global-state";
import { INFO_CARD_TYPE } from "@/features/cards/shared/card-routing/card-types";
import FocusContext from "@/services/map-management/focus-context";

type AddDeviceCardInstance = { VisibilityState: "hidden" | "visible" };

export function isAddDeviceCardOpen(): boolean {
    return FocusContext.currentInfoCard?.currentInfoCardType === INFO_CARD_TYPE.ADD_DEVICE;
}

/** Hides the add-device card and releases any focus context left on the stack (e.g. zone-selection panels). */
export async function closeAddDeviceIfOpen(): Promise<void> {
    if (!isAddDeviceCardOpen()) {
        return;
    }

    const addDeviceCard = AddDeviceGlobalState.AddDeviceCardInstance as AddDeviceCardInstance | undefined;

    if (addDeviceCard) {
        addDeviceCard.VisibilityState = "hidden";
    }

    if (addDeviceCard && FocusContext.currentInfoCard === addDeviceCard) {
        FocusContext.currentInfoCard = undefined;
    }

    AddDeviceGlobalState.isOnFinalStep = false;

    if (FocusContext.activeContext) {
        try {
            await FocusContext.releaseStack(FocusContext.activeContext);
        } catch (e) {
            console.warn("Error releasing add device focus context", e);
        }
    }
}
